export default __webpack_public_path__ + "assets/highest.68a846ef47951dc7857774178f0e88f7.mp3";